import { render, staticRenderFns } from "./CallNotification.vue?vue&type=template&id=fc46c936&scoped=true&lang=pug&"
import script from "./CallNotification.vue?vue&type=script&lang=ts&"
export * from "./CallNotification.vue?vue&type=script&lang=ts&"
import style0 from "./CallNotification.vue?vue&type=style&index=0&id=fc46c936&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc46c936",
  null
  
)

export default component.exports